import React, { Fragment } from "react";
import { Divider, Header, Segment } from "semantic-ui-react";
import SimpleBreadcrumbs from "./SimpleBreadcrumbs";

type SimpleDeviceFormLayoutProps = {
  actionType: string;
  beanName: string;
  onBack: Function;
  children: any;
};

const SimpleDeviceFormLayout = ({
  children,
  actionType,
  beanName,
  onBack,
}: SimpleDeviceFormLayoutProps) => {
  return (
    <Fragment>
      <SimpleBreadcrumbs
        title={`${beanName}s`}
        subtitle={actionType}
        onBack={onBack}
      />
      <Segment>
        <Header as='h3'>{`${actionType} ${beanName}`}</Header>
        <Divider />
        {children}
      </Segment>
    </Fragment>
  );
};

export default SimpleDeviceFormLayout;
